/* React Higher Order Component which fetches organization meta tag changes from import operation for organization where id = props.orgId & categoryId = props.categoryId
    Child (WrappedComponent) will render whether orgActMetaImportChanges is defined or not
    - NOTE: this component will NOT & CANNOT fetch this data automatically from the server.
    - This type of data is only generated as the response to an Meta Tags Tags CSV Import request
    child will receive props: {
        orgId:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        orgActMetaImportChanges: PropTypes.shape({
            tagsToAdd: PropTypes.array,
            tagsToDelete: PropTypes.array,
            tagsToUpdate: PropTypes.array,
            existingTagsHash: PropTypes.string.isRequired,
        })
    }

*/

import React from 'react';
import PropTypes from 'prop-types';

const OrganizationStore = require('../../stores/OrganizationStore');
const ReactUtil = require('../../util/ReactUtil');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const defaultProps = {};

export default function withOrganizationActivityMetaTagImportChanges(WrappedComponent) {
    class WithOrganizationActivityMetaTagImportChanges extends React.Component {
        constructor(props) {
            super(props);

            this.getChangesFromStoreState = this.getChangesFromStoreState.bind(this);
            this.state = {
                orgActMetaImportChanges: this.getChangesFromStoreState(),
                organizationStoreAction: OrganizationStore.getState().action,
            };

            this.unsubscribes = [OrganizationStore.listen(this.onOrganizationStoreChange.bind(this))];
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        getChangesFromStoreState() {
            const stateForOrg = OrganizationStore.getStateOrganization(this.props.orgId);
            if (!stateForOrg.orgActMetaImportChanges) {
                return undefined;
            }

            return stateForOrg.orgActMetaImportChanges[this.props.categoryId];
        }

        onOrganizationStoreChange(newState) {
            this.setState({
                orgActMetaImportChanges: this.getChangesFromStoreState(),
                organizationStoreAction: OrganizationStore.getState().action,
            });
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    orgActMetaImportChanges={this.state.orgActMetaImportChanges}
                    organizationStoreAction={this.state.organizationStoreAction}
                />
            );
        }
    }

    WithOrganizationActivityMetaTagImportChanges.propTypes = propTypes;
    WithOrganizationActivityMetaTagImportChanges.defaultProps = defaultProps;
    WithOrganizationActivityMetaTagImportChanges.displayName = `WithOrganizationActivityMetaTagImportChanges(${ReactUtil.getComponentDisplayName(WrappedComponent)})`;
    return WithOrganizationActivityMetaTagImportChanges;
}